class TabSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tabs = this.querySelectorAll('.tab');
    const contents = this.querySelectorAll('.tab-content');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => {
          t.setAttribute('aria-selected', 'false')
        });
        contents.forEach(c => {
          c.setAttribute('aria-hidden', 'true')
        });

        tab.setAttribute('aria-selected', 'true')
        contents[index].setAttribute('aria-hidden', 'false')
      });
    });

    // Show the first tab and content by default
    tabs[0]?.setAttribute('aria-selected', 'true')
    contents[0]?.setAttribute('aria-hidden', 'false')
  }
}

customElements.define('tab-switcher', TabSwitcher);
